var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_2972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.25534 0 2.83594 1.4194 2.83594 3.16406C2.83594 4.90873 4.25534 6.32812 6 6.32812C7.74466 6.32812 9.16406 4.90873 9.16406 3.16406C9.16406 1.4194 7.74466 0 6 0ZM6 5.625C4.64304 5.625 3.53906 4.52102 3.53906 3.16406C3.53906 1.8071 4.64304 0.703125 6 0.703125C7.35696 0.703125 8.46094 1.8071 8.46094 3.16406C8.46094 4.52102 7.35696 5.625 6 5.625ZM9.9367 8.3952C9.07045 7.51563 7.92209 7.03125 6.70312 7.03125H5.29688C4.07794 7.03125 2.92955 7.51563 2.0633 8.3952C1.20129 9.27045 0.726562 10.4258 0.726562 11.6484C0.726562 11.8426 0.883969 12 1.07812 12H10.9219C11.116 12 11.2734 11.8426 11.2734 11.6484C11.2734 10.4258 10.7987 9.27045 9.9367 8.3952ZM1.44516 11.2969C1.62129 9.30267 3.28151 7.73438 5.29688 7.73438H6.70312C8.71849 7.73438 10.3787 9.30267 10.5548 11.2969H1.44516Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_2972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.a12c6eb4ad9de45aa5764b31c166c89e.svg";
export { ForwardRef as ReactComponent };